import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';

class StaffChecksTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      staff_id: this.props.staff_id,
      base_id: null,
      checker_id: null,
      sae: '',
      gru: '',
      type: '',
      check_type: '',
      expiration: '',
      dispatch: '',
      date: '',
      hours: '',
      staff_checks: [],
      bases_list: [],
      staff_list: [],
      group_list: [
        {value: "1", label: "AVI"},
        {value: "2", label: "CEL"},
        {value: "3", label: "GMP"},
      ],
      type_list: [
        {value: "CHT", label: "CHT"},
        {value: "CCT", label: "CCT"},
      ],
      check_type_list: [
        {value: 0, label: "Cheque de inclusão"},
        {value: 1, label: "Cheque inicial"},
      ],
      simple_list: [
        {value: 0, label: "Sim"},
        {value: 1, label: "Não"},
      ],
      certification_list: []
    };

    //bind específico
    this.add = this.add.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.export = this.export.bind(this);
    this.refreshDataActive = this.refreshDataActive.bind(this);
    this.ativar = this.ativar.bind(this);
    this.desativar = this.desativar.bind(this);
  }
  
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  // Handlers
  handleSelectChangeGroup(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(this.state.loaded === 0 && Array.isArray(newProps.staff_checks)) {
      this.setState({
        staff_checks: newProps.staff_checks,
        bases_list: newProps.bases_list,
        staff_list: newProps.staff_list,
        loaded: 1
      });
    }
  }
  
  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      staff_id: this.state.staff_id,
      base_id: this.state.base_id,
      checker_id: this.state.checker_id,
      gru: this.state.gru,
      group: this.state.group,
      type: this.state.type,
      check_type: this.state.check_type,
      expiration: this.state.expiration,
      dispatch: this.state.dispatch,
      date: this.state.date,
      hours: this.state.hours,
     };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigmec') + '/colaborador/cheque', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({ staff_checks: responseJson.data });
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  
  // Fetch ativando um item
  ativar(event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de ativar esse cheque?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: id,
        only_active: this.state.only_active,
        staff_id: this.state.staff_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api_sigmec') + '/colaborador/cheque/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ staff_checks: responseJson.data });
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  
  // Fetch deletando um item
  desativar(event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de arquivar esse cheque?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: id,
        only_active: this.state.only_active,
        staff_id: this.state.staff_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api_sigmec') + '/colaborador/cheque/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ staff_checks: responseJson.data });
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  refreshData (event) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigmec') + '/colaborador/cheques/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({staff_checks: responseJson.data, only_active: 0});
        }
        if(typeof event.message !== 'undefined') {
          self.props.handleAlert(event.message, event.status, 'open');
        } else {
          self.props.handleAlert("", "", 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  refreshDataActive (event) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      var url = config.get('api_sigmec') + '/colaborador/cheques/ativos/' + self.state.staff_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({staff_checks: responseJson.data, only_active: 1});
        }
        if(typeof event.message !== 'undefined') {
          self.props.handleAlert(event.message, event.status, 'open');
        }else {
          self.props.handleAlert("", "", 'closed');
        }
      }).catch((error) => { 
        console.error(error);
      });
    });
  }
  export(event) {
    var self = this;
    var staff_stamp_id = event;
    var url = '/exportar/cheque/colaborador/';
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigmec') + url + staff_stamp_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        }
      });
    });
  }
  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">Cheques</h3>
  <hr/>
  {(this.state.staff_checks === null || typeof this.state.staff_checks === 'undefined') ?  <div><small><em>Nenhuma cheque cadastrada.</em></small><hr/></div> 
  : 
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="text-center">SAE</th>
          <th className="text-center">Tipo</th>
          <th className="text-center">Tipo de cheque</th>
          <th className="text-center">Checador</th>
          <th className="text-center">Base</th>
          <th className="text-center">AVI</th>
          <th className="text-center">CEL</th>
          <th className="text-center">GMP</th>
          <th className="text-center">Vencimento</th>
          <th className="text-center">Status</th>
          <th className="col-md-3 text-center">Ações</th>
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.staff_checks).map(function(k) {
          return (
            <tr>
              <td className="text-center">{self.state.staff_checks[k].sae}</td>
              <td className="text-center">{self.state.staff_checks[k].type}</td>
              <td className="text-center">{self.state.staff_checks[k].check_type_str}</td>
              <td className="text-center">{self.state.staff_checks[k].checador}</td>
              <td className="text-center">{self.state.staff_checks[k].base}</td>
              <td className="text-center">{self.state.staff_checks[k].avi}</td>
              <td className="text-center">{self.state.staff_checks[k].cel}</td>
              <td className="text-center">{self.state.staff_checks[k].gmp}</td>
              <td className="text-center">{self.state.staff_checks[k].expiration_str}</td>
              <td className="text-center">{(self.state.staff_checks[k].active === 1) ?  <span className="label label-success">ativo</span> : <span className="label label-danger">arquivado</span>}</td>
              <td className="text-center">
                {(self.state.staff_checks[k].active === 1) ?  
                  <button className="btn btn-sm btn-danger" value={self.state.staff_checks[k].id} onClick={self.desativar}><i className="fa fa-fw fa-power-off"></i></button>
                  :
                  <button className="btn btn-sm btn-success" value={self.state.staff_checks[k].id} onClick={self.ativar}><i className="fa fa-fw fa-power-off"></i></button>
                }
                <button className="btn btn-info btn-sm" onClick={() => {self.export(self.state.staff_checks[k].id)}}><i className="fa fa-fw fa-file-pdf-o"></i></button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }
  <h3 className="page-title">Adicionar cheque</h3>
  <hr/>
  <form onSubmit={this.add}> 
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Tipo:</label>
        <Select
          className="form-field-name"
          name="type"
          value={this.state.type}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'type')}
          options={this.state.type_list}
        />    
      </div>
      <div className="col-md-6 form-group">
        <label>Tipo de cheque:</label>
        <Select
          className="form-field-name"
          name="check_type"
          value={this.state.check_type}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'check_type')}
          options={this.state.check_type_list}
        />    
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Checador:</label>
        <Select
          className="form-field-name"
          name="checker_id"
          value={this.state.checker_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'checker_id')}
          options={this.state.staff_list}
        />    
      </div>
      <div className="col-md-6 form-group">
        <label>Base:</label>
        <Select
          className="form-field-name"
          name="base_id"
          value={this.state.base_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'base_id')}
          options={this.state.bases_list}
        />    
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>GRU:</label>
        <input type="text" className="form-control" name="gru" value={this.state.gru} onChange={this.handleChange.bind(this, 'gru')} />
      </div>
      <div className="col-md-6 form-group">
        <label>Grupo:</label>
        <Select
          className="form-field-name"
          name="group"
          value={this.state.group}
          searchable={true}
          multi={true}
          placeholder={''}
          onChange={this.handleSelectChangeGroup.bind(this, 'group')}
          options={this.state.group_list}
        />    
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Data:</label>
        <InputMask value={this.state.date}  maskChar={null} name="date" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder="" />
      </div>
      <div className="col-md-6 form-group">
        <label>Hora:</label>
        <input type="text" className="form-control" name="hours" value={this.state.hours} onChange={this.handleChange.bind(this, 'hours')} />
      </div>
    </div>
    <hr/>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Adicionar cheque</button>
  </form>
</div>
    );
  }
}

export default StaffChecksTab;



// WEBPACK FOOTER //
// ./src/Components/SigmecStaffs/Elements/StaffChecksTab.js